import type { ProjectType, ZohoContact } from '@deltasuite/zoho-client';
import { OUT_OF_SCOPE_CONTACT_TYPES, PROJECT_TYPE_TARGETS } from '@deltasuite/zoho-client';
import { dialApiFetch, isDialApiConfigured } from './client';
import { MOCK_CONTACTS } from './mock';

export interface PoolResponse {
  data: readonly ZohoContact[];
  info: {
    count: number;
    total_before_cooldown?: number;
    cooled_out?: number;
    project_types: readonly ProjectType[];
  };
}

export async function getPool(
  projectTypes: readonly ProjectType[],
  limit = 50,
): Promise<PoolResponse> {
  if (!isDialApiConfigured) {
    // Demo path: filter MOCK_CONTACTS by project-type allow-list (minus OOS).
    const allow = new Set<string>();
    for (const t of projectTypes) for (const v of PROJECT_TYPE_TARGETS[t]) allow.add(v);
    for (const oos of OUT_OF_SCOPE_CONTACT_TYPES) allow.delete(oos);
    const filtered = MOCK_CONTACTS.filter((c) => c.Company_Type && allow.has(c.Company_Type));
    return {
      data: filtered.slice(0, limit),
      info: { count: filtered.length, project_types: projectTypes },
    };
  }
  const qs = new URLSearchParams();
  if (projectTypes.length > 0) qs.set('projectTypes', projectTypes.join(','));
  qs.set('limit', String(limit));
  return dialApiFetch<PoolResponse>(`/v1/sprints/pool?${qs.toString()}`);
}
